var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"validContainer"}},[_c('div',{attrs:{"id":"validBG"}}),_vm._v(" "),_c('div',{staticStyle:{"left":"0"},attrs:{"id":"validMoveBox"}},[_c('i',{class:_vm.iconStyle})]),_vm._v(" "),_c('div',{attrs:{"id":"validTitle"}},[_vm._v("拖动滑块验证")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-397489b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slideValid.vue
// module id = null
// module chunks = 